import React from 'react';
import { convertUserFilter } from 'utils/helpers';
import { TableFilter } from 'components/UI/Table';
import { formatUserPosition } from './dataUtils';
import { IBreach } from 'types/breach';
import {
	createSortableHeader,
	createStoreFilter,
	createTextFormatter,
	createNameFormatter,
	createUserFilter,
	createBaseColumn,
} from './columnUtils';

/**
 * Создает колонку для номера магазина
 */
export const createStoreNumberColumn = (
	filter: TableFilter,
	setFilter: (filter: TableFilter) => void,
	storeIdOptions: Array<{ value: string; label: string }>,
	isFilterLocked: boolean,
	sortTable: (key: string) => void,
) => {
	const title = createSortableHeader('Номер магазина', 'checkin.store.number', filter, sortTable, {
		useShortLabel: true,
	});

	const formatted = createTextFormatter((row: IBreach) => row?.checkin?.store?.number);
	const filterComponent = createStoreFilter(filter, setFilter, storeIdOptions, isFilterLocked);

	return createBaseColumn('number', title, formatted, {
		width: '300px',
		filter: filterComponent,
	});
};

/**
 * Создает колонку для названия магазина
 */
export const createStoreTitleColumn = (filter: TableFilter, sortTable: (key: string) => void) => {
	const title = createSortableHeader('Название магазина', 'checkin.store.title', filter, sortTable, {
		useShortLabel: true,
	});

	const formatted = createTextFormatter((row: IBreach) => row?.checkin?.store?.title);

	return createBaseColumn('title', title, formatted, {
		width: '300px',
	});
};

/**
 * Создает колонку для типа услуги
 */
export const createPositionColumn = (filter: TableFilter, sortTable: (key: string) => void) => {
	const title = createSortableHeader('Тип услуги', 'user.position', filter, sortTable);

	const formatted = (row: any) => {
		const position = formatUserPosition(row.user);
		return <div>{position}</div>;
	};

	return createBaseColumn('position', title, formatted);
};

/**
 * Создает колонку для ФИО с фильтром
 */
export const createNameColumn = (
	filter: TableFilter,
	setFilter: (filter: TableFilter) => void,
	userList: any[],
	loadUser: (inputValue: string) => Promise<any[]>,
	isFilterLocked: boolean,
	sortTable: (key: string) => void,
	isLoadingUsers?: boolean,
) => {
	const title = createSortableHeader('ФИО', 'user.secondname', filter, sortTable);
	const formatted = createNameFormatter();
	const filterComponent = createUserFilter(filter, setFilter, userList, loadUser, isFilterLocked, convertUserFilter, isLoadingUsers);

	return createBaseColumn('name', title, formatted, {
		width: '500px',
		filter: filterComponent,
	});
};

// Реэкспорт функций из managerColumns для обратной совместимости
export { createRegionalDirectorColumn, createAoManagerColumn } from './managerColumns';
